import React from 'react';
import { useFormDepartureContext } from '../../../components/FormDepartureContext';

// Read-only — values come from the session via FormDepartureProvider userData
const PersonalInfoSection = () => {
  const { formData } = useFormDepartureContext();

  const readOnly = (id, label, value) => (
    <div className="ob-field">
      <label htmlFor={id} className="ob-label">{label}</label>
      <input id={id} type="text" value={value || ''} readOnly className="ob-input" style={{ opacity: 0.7, cursor: 'default' }} />
    </div>
  );

  return (
    <div className="form-section">
      <h4 className="ob-record-title" style={{ marginBottom: 12 }}>Personal Information</h4>
      <div style={{ display: 'grid', gap: 20 }}>
        {readOnly('company-name', 'Company Name', formData.company)}
        {readOnly('request-name', 'Request Name', formData.requestName)}
        {readOnly('email-info', 'Email', formData.email)}
      </div>
    </div>
  );
};

export default PersonalInfoSection;